import { createStore } from 'vuex';
import axios from 'axios';
import { qualityId2Array, elementId2Array } from '@/components/converters/ZodiacDetailsID2Arrayconverter';
import { signId2ArrayId } from '@/components/converters/signId2ArrayIdCalculator';
import { planetId2ArrayId } from '@/components/converters/signId2PlanetArrayCalculator.js';
// import { signName2ArrayId } from '@/components/converters/signNameCalculator.js';


export default createStore({
  state: {
    zodiacData: {
      signs: [],
      elements: [],
      qualities: [],
      houses: [],
      planets: []},
    baseUrl: process.env.VUE_APP_BASE_URL,
    // currentSignProfile: { signs: []},
    activeSignProfile: { signs: []},
    currentDescription: { },
    currentShortTitle: {},
    currentIcon: {}
  },
  getters: {
    zodiacData: state => {
        return state.zodiacData;
    },
    currentSignProfile: state => {
      return state.currentSignProfile;
    },
    activeSignProfile: state => {
      return state.activeSignProfile;
    },
    currentDescription: state => {
      return state.activeSignProfile;
    },
    currentShortTitle: state => {
      return state.currentShortTitle;
    },
    currentIcon: state => {
      return state.currentIcon;
    },
    filterZodiacData: (state) => (signName) => {
      // console.log('filterZodiacData check', signName, 'collection check: ', state.zodiacData.signs)
      return state.zodiacData.signs.find(profile => profile.signName === signName)
    }


    // filterZodiacData: (state, signName) => {
    //   // return state.zodiacData.filter(profile => profile.signName === signName)
    //   // return state.zodiacData.find(profile => profile.signName === signName)
    //   // console.log('signName is:', signName, state)

    //   const profile = state.zodiacData.signs.filter(profile => {
    //     // return profile.id === Number(id);
    //     return profile.signName === signName;
    //     // return profile.signName === 'Aries';
    //   });
    //   return profile[0];
    // }

  }, 
  mutations: {
    SET_ZodiacData (state, zodiacData) {
      state.zodiacData.signs = zodiacData
      // console.log('SET_ZodiacData signs array', state.zodiacData.signs)

    },
    SET_CurrentSign: (state, currentSign) => {
      //Default Config for profile

      // state.currentSignProfile.signs = state.currentSignProfile.signs.filter(currentSignProfile => currentSignProfile.signId == selectedSign),
      // console.log('SET_CurrentSign: itemCount', state, selectedSign, itemCount)
      // console.log('SET_CurrentSign: ', state.zodiacData[3].signName, currentSign)
      // console.log('SET_CurrentSign: ', state.zodiacData, 'currentSign is : ', currentSign.description)

      // console.log('current sign', state, currentSign[0].description)
      state.activeSignProfile = currentSign;
      state.currentDescription = currentSign.description;
      state.currentShortTitle = currentSign.shortDescription;
      state.currentIcon = currentSign.iconDisplayCharacter;

    },
    SET_Store_Elements: (state, elementDataIs) =>{
      let elementData = elementDataIs; 
      state.zodiacData.elements = elementData;
    },
    SET_Store_Qualities: (state, qualityIdIs) =>{
      let qualityId = qualityIdIs; 
      state.zodiacData.qualities = qualityId;
    },
    SET_Store_Houses: (state, houseIdIs) =>{
      let houseId = houseIdIs; 
      state.zodiacData.houses = houseId;
    },
    SET_Store_Planets: (state, planetIdIs) =>{
      let planetId = planetIdIs; 
      state.zodiacData.planets = planetId;
    },
    // SET_Current_Zodiac: (state, zodiacArrayIdIs) =>{
    //   let zodiacArray = parseInt(zodiacArrayIdIs);
    //   console.log('SET_Current_zodiacs', zodiacArray, state.zodiacData.signs[zodiacArray]);
    //   // state.currentDescription = state.zodiacData.signs[zodiacData].description;
    //   // state.currentShortTitle = state.zodiacData.signs[zodiacData].shortDescription;
    //   // state.currentIcon = state.zodiacData.signs[zodiacData].iconDisplayCharacter;

    // }, 
    SET_Current_Elements: (state, elementDataIs) =>{
      let elementData = elementDataIs;
      console.log('SET_Current_Elements', elementData, state.zodiacData.elements);
      state.currentDescription = state.zodiacData.elements[elementData].description;
      state.currentShortTitle = state.zodiacData.elements[elementData].title;
      state.currentIcon = state.zodiacData.elements[elementData].elementDisplayCharacter;

    },
    SET_Current_Quality: (state, quaityIdIs) =>{
      let quaityId = parseInt(quaityIdIs);

      console.log('SET_Current_Quality', quaityId, state.zodiacData.qualities);

      state.currentDescription = state.zodiacData.qualities[quaityId].description;
      state.currentShortTitle = state.zodiacData.qualities[quaityId].name;
      state.currentIcon = state.zodiacData.qualities[quaityId].qualityDisplayCharacter;
    },
    SET_Current_House: (state, houseIdIs) =>{
      let houseId = houseIdIs;
      console.log('SET_Current_House', houseId, state.zodiacData.houses);

      state.currentDescription = state.zodiacData.houses[houseId].description;
      state.currentShortTitle = state.zodiacData.houses[houseId].title;
      state.currentIcon = state.zodiacData.houses[houseId].houseDisplayCharacter;
    },
    SET_Current_Planet: (state, planetIdIs) =>{
      let planetId = planetIdIs;
      console.log('SET_Current_Planet', planetId, state.zodiacData.houses);

      state.currentDescription = state.zodiacData.planets[planetId].description;
      state.currentShortTitle = state.zodiacData.planets[planetId].name;
      state.currentIcon = state.zodiacData.planets[planetId].planetDisplayCharacter;
    }
    // SET_Current_Default_Details: (state, signArrayIdIs) => {
      // let signArrayId = signArrayIdIs;

      // console.log('SET_Current_Default_Details', zodiacData, state.zodiacData.signs);
      // console.log('SET_Current_Default_Details', state.zodiacData.signs, signArrayId);
      // console.log('SET_Current_Default_Details -getters :', this.state.zodiacData.signs, signArrayId);
      // this.getters.filterZodiacData(selectedSign)
      
      // state.currentDescription = state.zodiacData.signs[signArrayId].description;
      // state.currentShortTitle = state.zodiacData.signs[signArrayId].shortDescription;
      // state.currentIcon = state.zodiacData.signs[signArrayId].iconDisplayCharacter;
    // }
    
    // SET_activeSignProfile: (state, selectedSignID) => state.activeSignProfile = selectedSignID, //works without filter
    // SET_activeSignProfile: (state) => state.activeSignProfile = state.currentSignProfile.signs.filter(currentSignProfile => currentSignProfile.signId == 4), //works without filter
        
  },
  actions: {

    
    async loadZodiacData ({ commit }) {
      await axios.get(this.state.baseUrl)
          .then(response => {
            let zodiacData = response.data;
            // console.log('loadZodiacData chosenSignName is : ', chosenSignName); 
            // let chosenSignId = signName2SignId(chosenSignName);
            // console.log('loadZodiacData chosenSignId is: ', chosenSignName); 

            // let signId = parseInt(chosenSignId);
              

              //ORGANIZE DATA: Filter and set the selected profile details in the proper store
              // let activeProfile = response.data.signs.filter(currentSignProfile => currentSignProfile.signId === signId)
              

              // console.log('current sign is: ', activeProfile, chosenSignId, signId); 
              
              //removed display data
              // commit('SET_CurrentSign', activeProfile);
              // commit('SET_CurrentDescription', activeDescription);

              commit('SET_ZodiacData', zodiacData.signs);
              // commit('SET_Current_Zodiac', zodiacData.signs);
              commit('SET_Store_Elements', zodiacData.elements);
              commit('SET_Store_Qualities', zodiacData.qualities);
              commit('SET_Store_Houses', zodiacData.houses);
              commit('SET_Store_Planets', zodiacData.planets);
              

              // iterate through all elements and push each individual sign into the collection of profiles variable
              // for(var i = 0; i < zodiacData.elements.length; i++) {
              //   console.log('set this item to current ', zodiacData.elements[i]);
              //   commit('SET_Elements', zodiacData.elements[i]);
              // }

              // console.log('loadZodiacData profiles: ', signId, zodiacData.signs.length );

          // const signProfileArray = (this.state.currentSignProfile) => response.data.signs.filter(currentSignProfile => currentSignProfile.signId <= 11)
          // const signProfileArray = response.data.signs.filter(currentSignProfile => currentSignProfile.signId <= 12)
          // commit('SET_CurrentSignProfiles', signProfileArray);

            // console.log( 'signProfileArray ', signProfileArray)
          }).catch((e) => {
            console.error('error getting zodiac sign data to store: ', e)
          })


    },
    async getZodiacDetail({ commit }, detailsObj){
      // console.log('getZodiacDetail: detailsObj is ',  commit, detailsObj.detailType, detailsObj.detailId, qualityId2Array)
      // console.log('getZodiacDetail: detailId ',  detailId)
      let detailArrayId= 'unset value';
      
      //Process Elements
      if(detailsObj.detailType === 'element' ) {
          // console.log('getZodiacDetail element detailArrayId is:', detailArrayId)
          detailArrayId = elementId2Array(detailsObj.detailId);

         return commit('SET_Current_Elements', detailArrayId)
      } 
      //Process Qualities
      if(detailsObj.detailType === 'quality' ) {

        detailArrayId = qualityId2Array(detailsObj.detailId)
        // console.log('detailArrayId import checfk', detailArrayId, detailsObj.detailId)
         return commit('SET_Current_Quality', detailArrayId)
      }
      //Process Houses
      if(detailsObj.detailType === 'house' ) {

        detailArrayId =  signId2ArrayId(detailsObj.detailId)

      return commit('SET_Current_House', detailArrayId)
    }  
      //Process Planets
      if(detailsObj.detailType === 'planet' ) {

      detailArrayId = planetId2ArrayId(detailsObj.detailId);
      return commit('SET_Current_Planet', detailArrayId) 
    } 
    //   if(detailsObj.detailType === 'zodiac' ) { 
    //     detailArrayId = signId2ArrayId(detailsObj.detailId)
    //     console.log('detailArrayId : ', detailArrayId, '-detailsObj.detailType-', detailsObj.detailType)
    //     return commit('SET_Current_Zodiac', detailArrayId)
    // }
    else {
      //Process default sign details (Default)
        // if (detailsObj.detailId === null) {
        //   console.log('inner funciton hit')
        // }
        // console.log('zodaic if detailArrayId import check', detailArrayId, detailsObj.detailId)
        
        return console.log('undefined detail to display')
        
        // detailArrayId = signName2ArrayId(detailsObj.detailId)
        // console.log('other default: detailArrayId is', detailsObj, detailArrayId)
        // return commit('SET_Current_Zodiac', detailArrayId) 
      
    }


    },


    async getZodiacSignProfile({ commit }, signProfile){
      let selectedSign = signProfile;
      // console.log('getZodiacSignProfile: ', signName, selectedSign, commit, 'rootstate is: ', rootState.zodiacData)
      

      // let signArrayId = signName2ArrayId(selectedSign);
      // const selectedProfile = this.getters.filterZodiacData(selectedSign);
      // const selectedProfile = this.getters.filterZodiacData(selectedSign);
      // let selectedProfile = getters.zodiacData;
      
      // return console.log('store received profile req1', commit, selectedSign, collectionOfProfiles);
      // return console.log('store received profile req2', subdata);
      // // //   // return console.log('store received profile req', requestedId);
      // console.log('params check', this.$route.params.signId);
      // console.log('get profile state check', this.state.zodiacData);
      //Send ID of Requested Sign

      if ( selectedSign == undefined ) { 
        return console.log('undefined selected sign')
      } else {
      commit('SET_CurrentSign', selectedSign);
    }
      // commit('SET_activeSignProfile', selectedSign);
      // commit('SET_Current_Default_Details', signArrayId);
    // SET_Current_Default_Details: (state, signArrayIdIs) => {

      
      // console.log('getZodiacSignProfile: ', selectedSign, commit );
      // console.log('getZodiacSignProfile: ', signName, selectedSign, signArrayId, commit );
      // console.log('getZodiacSignProfile getters: ', getters.filterZodiacDat );
      // console.log('getZodiacSignProfile selectedProfile: ', selectedProfile);
      // console.log('getZodiacSignProfile gett store: ',  this.getters.filterZodiacData('Leo'));
      // console.log('getter test 2: ', this.$store.getters.filterZodiacData('Scorpio'))

    }

  },
  modules: {
  },
 
})